import { Box, Typography } from '@mui/material'
import { PureLightThemeCaaS } from 'src/theme/schemes/PureLightTheme'
import RotoCoinIcon2 from 'src/assets/RotoCoin2.svg'

interface FreeCreditsUiProps {
    freeCredits: number
    isCreditsAnimating: boolean
    creditsBoxRef: React.RefObject<HTMLDivElement>
}

const FreeCreditsUi = ({ freeCredits, isCreditsAnimating, creditsBoxRef }: FreeCreditsUiProps) => {
    return (
        <> <Box
            ref={creditsBoxRef}
            border={1}
            borderColor={isCreditsAnimating ? `${PureLightThemeCaaS.colors.alpha.orange[100]}` : `${PureLightThemeCaaS.colors.alpha.white[30]}`}
            borderRadius={1.5}
            p={0.5}
            gap={0.2}
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            sx={{
                bgcolor: "black",
                minWidth: "50px",
                transform: isCreditsAnimating ? "scale(1.05)" : "scale(1)",
                transition: "all 0s ease-in-out",
                borderWidth: isCreditsAnimating ? "1.2px" : "1px",
            }}
        >
            <img src={RotoCoinIcon2} alt="roto coin icon" width={20} height={"auto"} />

            <Typography variant="h3" sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}`, fontSize: 14 }}>
                {freeCredits}
            </Typography>
        </Box></>
    )
}

export default FreeCreditsUi